(function () {
    if (window.BBProductCardCarousel && typeof window.BBProductCardCarousel.init === 'function') {
      window.BBProductCardCarousel.init(document);
      return;
    }

    window.BBProductCardCarousel = {
      init: function (root) {
        var scope = root || document;
        var cards = scope.querySelectorAll('[data-bb-product-card]:not([data-bb-carousel-ready])');

        cards.forEach(function (card) {
          var mediaItems = Array.prototype.slice.call(card.querySelectorAll('[data-bb-media]'));
          var prevBtn = card.querySelector('[data-bb-prev]');
          var nextBtn = card.querySelector('[data-bb-next]');
          var mediaLink = card.querySelector('[data-bb-media-link]');
          var dots = Array.prototype.slice.call(card.querySelectorAll('[data-bb-dot]'));

          card.setAttribute('data-bb-carousel-ready', 'true');

          if (!mediaItems.length) return;

          var currentIndex = 0;
          var startX = 0;
          var startY = 0;
          var movedX = 0;
          var movedY = 0;
          var isTouching = false;
          var suppressClick = false;

          function setExternalVideoState(mediaItem, shouldPlay) {
            mediaItem.querySelectorAll('iframe').forEach(function (iframe) {
              if (!iframe.contentWindow) return;

              var videoType = iframe.getAttribute('data-video-type');
              if (videoType === 'youtube') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  event: 'command',
                  func: shouldPlay ? 'playVideo' : 'pauseVideo',
                  args: []
                }), '*');
              } else if (videoType === 'vimeo') {
                iframe.contentWindow.postMessage(JSON.stringify({
                  method: shouldPlay ? 'play' : 'pause'
                }), '*');
              }
            });
          }

          function updateVideoState(mediaItem, isPlaying) {
            mediaItem.setAttribute('data-bb-video-playing', isPlaying ? 'true' : 'false');
          }

          function hydrateImages(mediaItem) {
            mediaItem.querySelectorAll('[data-bb-deferred-image]').forEach(function (image) {
              var src = image.getAttribute('data-bb-src');
              var srcset = image.getAttribute('data-bb-srcset');

              if (srcset) image.setAttribute('srcset', srcset);
              if (src) image.setAttribute('src', src);

              image.removeAttribute('data-bb-src');
              image.removeAttribute('data-bb-srcset');
              image.removeAttribute('data-bb-deferred-image');
            });
          }

          function hydrateDeferredPlayers(mediaItem) {
            mediaItem.querySelectorAll('deferred-media').forEach(function (deferredMedia) {
              if (deferredMedia.querySelector('video, iframe')) return;

              var template = deferredMedia.querySelector('template');
              if (!template || !template.content) return;

              deferredMedia.appendChild(template.content.cloneNode(true));
              template.remove();
            });
          }

          function playMedia(mediaItem) {
            if (!mediaItem.classList.contains('bb-product-card__media-item--video') || card.closest('[hidden]')) return;

            hydrateDeferredPlayers(mediaItem);

            mediaItem.querySelectorAll('video').forEach(function (video) {
              video.muted = true;
              video.loop = true;
              video.playsInline = true;

              var playPromise = video.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(function () {});
              }
            });

            setExternalVideoState(mediaItem, true);
            updateVideoState(mediaItem, true);
          }

          function pauseMedia(mediaItem) {
            mediaItem.querySelectorAll('video').forEach(function (video) {
              video.pause();
            });

            setExternalVideoState(mediaItem, false);
            updateVideoState(mediaItem, false);
          }

          function setActive(index, fromUser) {
            if (!mediaItems.length) return;

            if (index < 0) index = mediaItems.length - 1;
            if (index >= mediaItems.length) index = 0;

            currentIndex = index;

            mediaItems.forEach(function (mediaItem, mediaIndex) {
              var isActive = mediaIndex === currentIndex;
              mediaItem.classList.toggle('is-active', isActive);
              mediaItem.setAttribute('aria-hidden', isActive ? 'false' : 'true');

              if (isActive) {
                hydrateImages(mediaItem);
                mediaItem.removeAttribute('inert');
                playMedia(mediaItem);
              } else {
                mediaItem.setAttribute('inert', '');
                pauseMedia(mediaItem);
              }
            });

            dots.forEach(function (dot, dotIndex) {
              dot.classList.toggle('is-active', dotIndex === currentIndex);
            });

            if (fromUser) {
              card.classList.add('is-carousel-active');
            }
          }

          function resetCarousel() {
            card.classList.remove('is-carousel-active');
            setActive(0, false);
          }

          setActive(0, false);

          if ('IntersectionObserver' in window && mediaItems[1]) {
            var adjacentMediaObserver = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                hydrateImages(mediaItems[1]);
                adjacentMediaObserver.disconnect();
              });
            }, { rootMargin: '250px' });

            adjacentMediaObserver.observe(card);
          }

          card.addEventListener('mouseenter', function () {
            if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            if (!card.classList.contains('has-hover-image') || card.classList.contains('is-carousel-active')) return;
            setActive(1, false);
          });

          if (prevBtn) {
            prevBtn.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              setActive(currentIndex - 1, true);
            });
          }

          if (nextBtn) {
            nextBtn.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              setActive(currentIndex + 1, true);
            });
          }

          card.addEventListener('bb:card-media-reset', function () {
            resetCarousel();
            mediaItems.forEach(pauseMedia);
          });

          card.addEventListener('mouseleave', function () {
            if (window.matchMedia && !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
            if (card.classList.contains('bb-options-active')) return;
            resetCarousel();
          });

          if (mediaLink && mediaItems.length > 1) {
            mediaLink.addEventListener('touchstart', function (event) {
              if (!event.touches || !event.touches.length) return;

              hydrateImages(mediaItems[(currentIndex + 1) % mediaItems.length]);
              hydrateImages(mediaItems[(currentIndex - 1 + mediaItems.length) % mediaItems.length]);

              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              movedX = 0;
              movedY = 0;
              isTouching = true;
              suppressClick = false;
            }, { passive: true });

            mediaLink.addEventListener('touchmove', function (event) {
              if (!isTouching || !event.touches || !event.touches.length) return;

              movedX = event.touches[0].clientX - startX;
              movedY = event.touches[0].clientY - startY;

              if (Math.abs(movedX) > 16 && Math.abs(movedX) > Math.abs(movedY)) {
                event.preventDefault();
              }
            }, { passive: false });

            mediaLink.addEventListener('touchend', function () {
              if (!isTouching) return;

              isTouching = false;

              if (Math.abs(movedX) > 40 && Math.abs(movedX) > Math.abs(movedY)) {
                suppressClick = true;

                if (movedX < 0) {
                  setActive(currentIndex + 1, true);
                } else {
                  setActive(currentIndex - 1, true);
                }

                window.setTimeout(function () {
                  suppressClick = false;
                }, 260);
              }
            }, { passive: true });

            mediaLink.addEventListener('click', function (event) {
              if (!suppressClick) return;

              event.preventDefault();
              event.stopPropagation();
              suppressClick = false;
            });
          }
        });
      }
    };

    window.BBProductCardCarousel.init(document);

    document.addEventListener('shopify:section:load', function (event) {
      window.BBProductCardCarousel.init(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      window.BBProductCardCarousel.init(event.target);
    });

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        var shouldInit = false;

        mutations.forEach(function (mutation) {
          if (mutation.addedNodes && mutation.addedNodes.length) {
            shouldInit = true;
          }
        });

        if (shouldInit) {
          window.BBProductCardCarousel.init(document);
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  })();
